import { render } from "./index.vue?vue&type=template&id=0ffd676a"
import script from "./radio-slider.ts?vue&type=script&lang=js"
export * from "./radio-slider.ts?vue&type=script&lang=js"

import "./radio-slider.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script